(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ss-card-atc"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__sscaInit)return;window.__sscaInit=true;
  document.addEventListener('click',function(e){
    var o=e.target.closest&&e.target.closest('.ssca__opt');
    if(o){
      e.preventDefault();e.stopPropagation();
      var r=o.closest('[data-ssca]');
      r.querySelectorAll('.ssca__opt').forEach(function(b){b.setAttribute('aria-checked',b===o?'true':'false');});
      r.querySelector('[name=id]').value=o.dataset.id;
      var p=r.querySelector('.ssca__p');if(p)p.textContent=o.dataset.price;
      return;
    }
    if(e.target.closest&&e.target.closest('.ssca__btn'))e.stopPropagation();
  },true);
  document.addEventListener('submit',function(e){
    var f=e.target.closest&&e.target.closest('.ssca__f');if(!f)return;
    e.preventDefault();
    var btn=f.querySelector('.ssca__btn'),t=btn.querySelector('.ssca__t'),old=t.textContent;
    if(btn.classList.contains('is-busy'))return;
    btn.classList.add('is-busy');
    var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+f.querySelector('[name=id]').value,quantity:1}]})})
    .then(function(r){if(!r.ok)throw r;return fetch(base+'cart.js');})
    .then(function(r){return r.json();})
    .then(function(cart){
      btn.classList.remove('is-busy');btn.classList.add('is-done');t.textContent=f.dataset.added||'Added';
      setTimeout(function(){btn.classList.remove('is-done');t.textContent=old;},1600);
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'ss-card-atc',data:{source:'ss-card-atc',itemCount:cart.item_count}}}));
    })
    .catch(function(){btn.classList.remove('is-busy');f.submit();});
  });
})();
  } catch(e) { console.error(e); }
})();

})();
